import { Regular } from "./components/Regular";
import { Short } from "./components/Short";

export const ModerationInfo = {
  Regular,
  Short,
};
